import { render, staticRenderFns } from "./OrganizationModel.vue?vue&type=template&id=afefa14e&scoped=true"
import script from "./OrganizationModel.vue?vue&type=script&lang=js"
export * from "./OrganizationModel.vue?vue&type=script&lang=js"
import style0 from "./OrganizationModel.vue?vue&type=style&index=0&id=afefa14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afefa14e",
  null
  
)

export default component.exports